// extracted by mini-css-extract-plugin
export default {"iconButton":"IconButton_iconButton__YDGjK","md":"IconButton_md__IX5Rm","lg":"IconButton_lg__nuy1g"};